module.exports = __webpack_public_path__ + "static/media/icone-compartilhar-branco.bbe74caf.svg";